<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-card color="transparent" flat>
      <v-toolbar color="transparent" flat>
        <v-toolbar-title class="font-weight-bold">{{ texts.title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="openUploadGenetics">{{ texts.newUpload }}</v-btn>
      </v-toolbar>
      <v-card outlined class="v-card__body">
        <v-card flat>
          <v-card-text class="px-0 py-0">
            <v-tabs class="tabs-pill" v-model="tab">
              <v-tab>{{ texts.tabs.recent }}</v-tab>
              <v-tab>{{ texts.tabs.history }}</v-tab>
            </v-tabs>
          </v-card-text>
        </v-card>
        <v-card-text class="mt-5 pa-0">
          <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            hide-default-footer
            :items-per-page="5"
            :loading="loading"
            :options.sync="tableOptions"
            :server-items-length="totalItems"
            loading-text="$t('loadingPleaseWait')"
          >
            <template v-slot:top>
              <div class="d-flex mt-5">
                <v-col cols="4" class="pl-0">
                  <v-text-field
                    prepend-inner-icon="mdi-magnify"
                    outlined
                    height="5px"
                    placeholder="Search"
                    dense
                    v-model="search"
                    class="shrink"
                    v-if="tab !== 0"
                  ></v-text-field>
                </v-col>
                <v-spacer></v-spacer>
                <v-btn
                  v-if="tab !== 0"
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="tableOptions.page <= 1"
                  @click="pageChange(false)"
                >
                  <v-icon dark> mdi-chevron-left </v-icon>
                </v-btn>
                <v-btn
                  v-if="tab !== 0"
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="tableOptions.page >= totalPages"
                  @click="pageChange(true)"
                >
                  <v-icon dark> mdi-chevron-right </v-icon>
                </v-btn>
                <div v-if="tab !== 0" class="py-1 title">
                  {{ from }} - {{ to }} of {{ totalItems }}
                </div>
              </div>
            </template>
            <template v-if="items.length > 0" v-slot:body="{ items }">
              <tbody>
                <tr
                  v-for="(item, index) in items"
                  :key="index"
                  style="position: relative; width: 0; height: 0"
                >
                  <td>
                    <h4>{{ item.createdBy.firstName }} {{ item.createdBy.lastName }}</h4>
                    <small class="disabled">{{ formatDate(item.createdAt) }}</small>
                  </td>
                  <td>{{ item.uploadFile }}</td>
                  <td>{{ item.noOfAnimals }}</td>
                  <td>
                    <v-chip 
                      :class="'status-chip bg-t-' + status[item.status]?.color" 
                      :color="status[item.status]?.color"
                      outlined>
                      {{ status[item.status]?.text }}
                    </v-chip>
                  </td>
                  <td>
                    <div class="row" v-if="item.message">
                      <div class="col-2 centered">
                        <div :class="'pill bg-t-' + status[item.status]?.color">
                          <v-icon
                            :color="status[item.status]?.color" 
                            small>
                            {{ status[item.status]?.icon }}
                          </v-icon>
                        </div>
                      </div>
                      <div class="col-10">
                        <h4>{{ status[item.status]?.result }}</h4>
                        <small class="disabled">{{ item.message }}</small>
                      </div>
                    </div>
                  </td>
                  <td>
                    <a :href="item.reportFile" :download="`failed_animals_${new Date()}`"> 
                           <v-btn
                      v-if="item.reportFile"
                      outlined
                      color="success"
                      >
                      {{ texts.exportButton }} 
                      </v-btn>
                    </a>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-card>
    <ConfirmBox
      :title="texts.confirm.title"
      :message="texts.confirm.message"
      :cancelBtnText="texts.confirm.cancel"
      :confirmBtnText="texts.confirm.confirm"
      :confirmData="texts.confirm.confirmData"
      :dialog="confirm"
      @confirm:action="refreshPage"
    />
    <UploadGenetics
      :dialogI="showUploadGenetics"
      @closeUploadGenetics="closeUploadGenetics">
    </UploadGenetics>
  </div>
</template>

<script>
//import EPDService from "@/_services/EPDService";
// import FileService from "@/_services/FileService";
import UploadGenetics from "@/views/genetics/UploadGenetics";
import gql from "graphql-tag";

import ConfirmBox from "@/components/ConfirmBox";
import moment from 'moment';


export default {
  apollo: {

    eventsData: {
          query: gql`
      query events($type: String!,$page: Int!,$limit: Int!,$searchPhrase: String!) {
        events(type:$type,page:$page,limit :$limit,searchPhrase:$searchPhrase) {
          count
      totalCount
      rows{
        id
        uploadFile
        reportFile
        noOfAnimals
        message
        createdAt
        status
        createdBy {
          id
          firstName
          lastName
        }
      }
        }
      }`,
          variables() {
              return {
                  searchPhrase: this.search,
                  type: this.type,
                  page: this.tableOptions.page,
                  limit: this.tableOptions.itemsPerPage,
              };
          },
          skip:true,
          result: function ({ data }) {
           
              if (data.events) {

                this.items = data.events.rows;
                console.log( this.items," this.items this.items")
                this.items.forEach((eventRecord, index) => {
                  this.items[index].eventDate = new Date(eventRecord.createdAt).toLocaleString();
                });

              this.totalItems = data.events.totalCount;

              this.totalPages = Math.ceil(
                this.totalItems / this.tableOptions.itemsPerPage
              );

              this.from = (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage + 1;
              this.to =  this.tableOptions.page * this.tableOptions.itemsPerPage -
              (this.tableOptions.itemsPerPage - data.events.rows.length);
    
              }
          },
          update: (data) => {
              return data.events;
          },
          error: (err) => {
              console.log(err)
          }

      },
},
  name: 'BulkUploadStatus',
  // mounted() {
  //   this.getUploads();
  // },
  components: {
    UploadGenetics,
    ConfirmBox
  },
  data () {
    return {
      breadcrumbs: [
        {
          text: this.$t('dashboard'),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t('Genetics & Breeding'),
          disabled: false,
          link: true,
          exact: true,
          to: { name: "Genetics" },
        },
        {
          text: "Manage Bulk Uploads",
          disabled: true
        }
      ],
      texts: {
        title: "Multiple Animals Upload History",
        newUpload: "New Bulk Upload",
        tabs: {
          recent: "Recent Uploads",
          history: "History"
        },
        confirm: {
          title: "Bulk Upload Queued",
          message: "Your uploaded file is currently being processed. You can monitor the progress by checking the \"Manage Bulk Animals\" menu. We will notify you via email as soon as the system has completed processing your file.",
          cancel: "Close",
          confirm: "Manage Bulk Animals",
          confirmData: {}
        },
        exportButton: "Export Pending Animals"
      },
      status: {
        pending: {
          text: "Pending",
          color: "amber",
        },
        processing: {
          text: "In Progress",
          color: "primary",
        },
        completed_with_errors: {
          text: "Completed With Errors",
          color: "orange",
          icon: "mdi-exclamation",
          result: "Partial"
        },
        failed: {
          text: "Failed to Upload",
          color: "red",
          icon: "mdi-close",
          result: "Failed"
        },
        complete: {
          text: "Uploaded Successfully",
          color: "success",
          icon: "mdi-check",
          result: "Done"
        },
      },
      from: 0,
      to: 0,
      tab: 0,
      tableOptions: {},
      loading: false,
      search: "",
      type:"recent",
      totalPages: 1,
      totalItems: 0,
      items: [],
      headers:  [
        { text: "User Name/Time" },
        { text: "File" },
        { text: "Total # of Animals" },
        { text: "Status" },
        { text: "Results" },
        { text: "" }
      ],
      showUploadGenetics: false,
      confirm: false
    }
  },
  methods: {
    formatDate(timestamp){
      const date = new Date(timestamp);
      return moment(date).format('YYYY-MM-DD');
    },
    getUploads() {

      this.type = (this.tab === 0) ? 'recent':"history";
      this.searchPhrase = this.search;
      this.$apollo.queries.eventsData.skip = false;
      this.$apollo.queries.eventsData.refetch();

      // this.loading = true;
      // const endpoint = (this.tab === 0) ? '/recent': `?page=${this.tableOptions.page}&limit=${this.tableOptions.itemsPerPage}&searchPhrase=${this.search}`;
      // EPDService.getBulkUploadStatus(endpoint)
      //   .then((res) => {
      //     if (res.success) {
      //       this.items = res.data.rows;
      //       this.items.forEach((eventRecord, index) => {
      //         this.items[index].eventDate = new Date(eventRecord.createdAt).toLocaleString();
      //       });

      //       this.totalItems = res.data.count;

      //       this.totalPages = Math.ceil(
      //         this.totalItems / this.tableOptions.itemsPerPage
      //       );

      //       this.from = (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage + 1;
      //       this.to =
      //         this.tableOptions.page * this.tableOptions.itemsPerPage -
      //         (this.tableOptions.itemsPerPage - res.data.rows.length);

      //       this.loading = false;
      //     } else {
      //       this.$notify({
      //         title: "Error fetching bulk upload data",
      //         text: res.data.message,
      //         type: "error",
      //       });
      //       this.loading = false;
      //     }
      //   })
      //   .catch((err) => {
      //     this.loading = false;
      //     console.log(err);
      //   });
    },
    pageChange(t) {
      if (t) {
        this.tableOptions.page = this.tableOptions.page + 1
        return
      } else {
        this.tableOptions.page = this.tableOptions.page - 1
        return
      }
    },
    openUploadGenetics() {
      this.showUploadGenetics = true;
    },
    closeUploadGenetics(success) {
      if (success === true) {
        this.confirm = true;
      }
      this.showUploadGenetics = false;
    },
    refreshPage(action) {
      if (action) {
        this.getUploads();
      }
      this.confirm = false;
    }
  },
  watch: {
    tab: {
      handler() {
        this.getUploads();
      }
    },
    tableOptions: {
      handler() {
        this.getUploads();
      },
      deep: true,
      immediate: false
    },
    search: {
      handler() {
        this.getUploads();
      },
      deep: true
    }
  },
};
</script>

<style scoped>
.v-card__body {
  background-color: #ffffff;
  padding: 24px;
  margin: 16px;
}

.centered {
  display: flex;
  justify-content: center;
  align-items: center;
}

.pill {
  padding: 6px 8px;
  border-radius: 50%;
}

.bg-t-orange, .v-chip.v-chip--outlined.v-chip.v-chip.bg-t-orange {
  background-color: rgba(255, 152, 0, 0.1) !important;
}

.bg-t-success, .v-chip.v-chip--outlined.v-chip.v-chip.bg-t-success {
  background-color: rgba(76, 175, 80, 0.1) !important;
}

.bg-t-red, .v-chip.v-chip--outlined.v-chip.v-chip.bg-t-red {
  background-color: rgba(240, 55, 55, 0.1) !important;
}

.bg-t-amber, .v-chip.v-chip--outlined.v-chip.v-chip.bg-t-amber {
  background-color: rgba(255, 193, 7, 0.1) !important;
}

.bg-t-primary, .v-chip.v-chip--outlined.v-chip.v-chip.bg-t-primary {
  background-color: rgba(24, 103, 192, 0.1) !important;
}

table a {
  text-decoration: underline;
}
</style>
